module.exports = __webpack_public_path__ + "img/pic_300014.5c553ecb.jpg";